import { useEffect, useState } from "react";
import { Typography, Card } from "@mui/material";
import EducationCard from "./EducationCard";
import educationData from '../Data/education.json'
import useIsMobile from "../AppHelpers";

export interface Education {
    subject?: string,
    qualificationName: string,
    length: number,
    description: string,
    type:string,
    status:string
}


const EducationSection = ()=> {
    const [educationList, setEducationList] = useState<Education[]>([]);
    const [showMore, setShowMore] = useState(false);
    const [numOfItems, setNumOfItems] = useState(1);
    const isMobile = useIsMobile()

    useEffect(()=>{
        setEducationList(educationData)
    },[])

    const handleShowMore = () =>{
        setShowMore(!showMore)
    }

    const getText =() =>{
        return showMore ? 'Less...' :'More...'
    }

    useEffect(()=>{
        if(showMore){
            setNumOfItems(educationList.length)
        } else{
            setNumOfItems(1)
        }
    
    },[showMore, educationList])
        
    const getAllowedWidth =()=>{
        return isMobile ? '100vw':'50vw'
    }

    return (
      <Card id='education' className="CareerSection ma-2"  raised={true} sx={{backgroundColor:'#420A02', width:{getAllowedWidth}, padding:'2rem', margin:'2rem',textAlign:'left'}}>
        <Typography variant="h3" className='mb-0'  align={'left'} sx={{color: '#fff'}}>Education / Qualifcations</Typography>
        {educationList.map((education, i )=> numOfItems >= i && 
             <EducationCard education={education}></EducationCard>
        )}
         {educationList.length > 2 &&<Typography variant="h5" className='mt-2'  align={'right'} sx={{color: '#fff', marginTop:'1rem','&:hover':{
              cursor:'pointer'
            }}} onClick={handleShowMore}>{getText()}</Typography>} 
      </Card>
    );
  }
  
  export default EducationSection;